function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 42.5V14.2H234V0h-24.9c-28.4 0-52.1 19.6-58.4 46.1H65.2C29.2 46.1 0 75.3 0 111.3v32.6c0 35.9 29.2 65.2 65.2 65.2h89.3c20.3 0 36.9 16.5 36.9 36.9v37.6h28.3V246c0-36-29.2-65.2-65.2-65.2H65.2c-20.3 0-36.9-16.5-36.9-36.9v-32.6c0-20.3 16.5-36.9 36.9-36.9h85.5c6.3 26.4 30.1 46.1 58.4 46.1H234v-14.2h49.4V78H234V42.5h49.5z"
})));